export enum ChartScales {
  time = "time",
  point = "point",
}
export type ChartScalesType = keyof typeof ChartScales;

export enum ChartTimeframes {
  alltime = "alltime",
  year = "year",
  halfyear = "halfyear",
  quarter = "quarter",
  month = "month",
  week = "week",
  day = "day",
}
export type ChartTimeframesType = keyof typeof ChartTimeframes;

export enum TabValues {
  chart = "chart",
  timeline = "timeline",
  experiences = "experiences",
  activities = "activities",
  goals = "goals",
  strengths = "strengths",
  crisis = "crisis",
  notes = "notes",
}
export type TabValueType = keyof typeof TabValues;
